import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { PaperPlaneTilt } from "@phosphor-icons/react/PaperPlaneTilt";
import { useFormik } from "formik";
import { FC, useMemo } from "react";
import { dayjs } from "utils";

import { DashboardContentLayout } from "~ui-components/components/atoms/dashboard-content-layout";
import {
	AccountEditSubscription,
	EditSubscriptionFormValues,
} from "~ui-components/components/organisms/user-accounts/edit-subscription";
import { AccountEditSubscriptionSummary } from "~ui-components/components/organisms/user-accounts/edit-subscription-summary";
import {
	Account,
	PreviewSubscriptionChangeResults,
	SUBSCRIPTION_TYPE,
} from "~ui-components/types/__generated/gql/graphql";

interface EditSubscriptionProps {
	isTrialExpired: boolean;
	isAccountClosed: boolean;
	account: Account;
	form: ReturnType<typeof useFormik<EditSubscriptionFormValues>>;
	onContinueTrial: () => void;
	subscriptionChangePreview?: PreviewSubscriptionChangeResults;
	isSubscriptionChangeLoading?: boolean;
}

export const EditSubscription: FC<EditSubscriptionProps> = (props) => {
	const { form, account, isTrialExpired, isAccountClosed } = props;

	const pageTitle = useMemo(() => {
		if (
			account.subscription.type === SUBSCRIPTION_TYPE.TRIAL &&
			dayjs(account.subscription.trialExpiresAt).isBefore(dayjs())
		)
			return "Your trial has expired - subscribe to continue";

		if (account.subscription.type === SUBSCRIPTION_TYPE.CLOSED)
			return "Your account is closed - subscribe to reactivate";

		return "Manage subscription";
	}, [account]);

	return (
		<DashboardContentLayout
			pageTitle={pageTitle}
			disableBackButton={isTrialExpired || isAccountClosed}
			action={
				isTrialExpired || isAccountClosed ? (
					<Button
						startIcon={<PaperPlaneTilt />}
						variant="contained"
						href="mailto:sales@mangomap.com">
						Contact sales
					</Button>
				) : null
			}>
			<Stack
				spacing={4}
				component={"form"}
				onSubmit={form.handleSubmit}>
				<Grid
					container
					spacing={4}>
					<Grid
						item
						md={8}
						xs={12}>
						<AccountEditSubscription form={form} />
					</Grid>
					<Grid
						item
						md={4}
						xs={12}>
						<AccountEditSubscriptionSummary {...props} />
					</Grid>
				</Grid>
			</Stack>
		</DashboardContentLayout>
	);
};
